import React from 'react'
import './ProgressBar.css'

export const Filler = props => {
    return <div className={props.processing ? 'Filler upload-processing' : 'Filler'} style={{width: `${props.percentage}%`, background: `${props.color}`}}/>
}
